import React from 'react';
import Usericon from '../assets/img/user.svg';
import Calendaricon from '../assets/img/calendar.svg';
import Arrowicon from '../assets/img/right_arrow.svg';

const BlogCard = ({ post, height = '330px', style = {} }) => {
  return (
    <div className="blog_outer"   >
      <img src={`${post.image}`} alt="" />
      <div className="blog_content">

        <div className="meta-box">
         
        </div>
        <div className="blog-content">
          <div className="blog_title">
                <h2>{post.title}</h2>
                 <div className="usern">                  
                    <div className="auth">
                      <img src={Usericon} width="25" height="25" alt="user" /> {post.author} 
                    </div>                    
                    <div className="datepost">
                        <img src={Calendaricon} width="25" height="25" alt="user" />  {post.date}
                    </div>                                       
                </div>
          </div>          
          <p>{post.excerpt}</p>
          <a href={post.link}>Read the article <span><img src={Arrowicon} width="25" height="25" alt="user" /></span></a>
        </div>
      </div>
    </div>
  );
};

export default BlogCard;
